import { render, staticRenderFns } from "./NoAloneBox.vue?vue&type=template&id=0a73963f&scoped=true"
import script from "./NoAloneBox.vue?vue&type=script&lang=js"
export * from "./NoAloneBox.vue?vue&type=script&lang=js"
import style0 from "./NoAloneBox.vue?vue&type=style&index=0&id=0a73963f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a73963f",
  null
  
)

export default component.exports